import React from 'react'

interface MathVisualProps {
  operationSymbol: string
  valueOne: string
  valueOneLabel: string
  valueTwo: string
  valueTwoLabel: string
  result: string
  resultLabel: string
}

export const MathVisual: React.FC<MathVisualProps> = ({ operationSymbol, valueOne, valueOneLabel, valueTwo, valueTwoLabel, result, resultLabel }) => {
  return (
    <>
      <div>
        <h1 className='text-2xl'>{valueOne}</h1>
        <h3 className='text-xs text-gray-400 mt-1'>{valueOneLabel}</h3>
      </div>
      <div className='text-3xl'>
        {operationSymbol}
      </div>
      <div>
        <h1 className='text-2xl'>{valueTwo}</h1>
        <h3 className='text-xs text-gray-400 mt-1'>{valueTwoLabel}</h3>
      </div>
      <div className='text-3xl'>
        =
      </div>
      <div>
        <h1 className='text-2xl'>{result}</h1>
        <h3 className='text-xs text-gray-400 mt-1'>{resultLabel}</h3>
      </div>
    </>
  )
}
